import { WebGLGPUBuffer } from './buffer_webgl.js';
import { GPUResourceUsageFlags, StructuredBufferData, PBPrimitiveType } from '@zephyr3d/device';

class WebGLStructuredBuffer extends WebGLGPUBuffer {
    _structure;
    _data;
    constructor(device, structure, usage, source){
        if (!structure?.isStructType()) {
            throw new Error('invalid structure type');
        }
        if (usage & GPUResourceUsageFlags.BF_INDEX) {
            throw new Error('structured buffer must not have Index usage flag');
        }
        if (usage & (GPUResourceUsageFlags.BF_READ | GPUResourceUsageFlags.BF_WRITE | GPUResourceUsageFlags.BF_PACK_PIXEL | GPUResourceUsageFlags.BF_UNPACK_PIXEL)) {
            throw new Error('structured buffer must not have Read or Write usage flags');
        }
        if (usage & GPUResourceUsageFlags.BF_VERTEX) {
            if (structure.structMembers.length !== 1 || !structure.structMembers[0].type.isArrayType()) {
                throw new Error('structured buffer for vertex usage must have only one array member');
            }
            if (!WebGLStructuredBuffer.isValidArrayElementType(structure.structMembers[0].type.elementType)) {
                throw new Error('invalid vertex data type when creating vertex buffer');
            }
        }
        const layout = structure.toBufferLayout(0, structure.layout);
        if (source && layout.byteSize !== source.byteLength) {
            throw new Error(`create structured buffer failed: invalid source size: ${source.byteLength}, should be ${layout.byteSize}`);
        }
        const useSystemMemory = !device.isWebGL2 && (usage & GPUResourceUsageFlags.BF_UNIFORM) !== 0;
        super(device, usage, source || layout.byteSize, useSystemMemory);
        this._data = new StructuredBufferData(layout, useSystemMemory ? this.systemMemoryBuffer : this);
        this._structure = structure;
    }
    set(name, value) {
        this._data.set(name, value);
    }
    get structure() {
        return this._structure;
    }
    set structure(st) {
        if (st && !st.isCompatibleType(this._structure)) {
            const layout = st.toBufferLayout(0, st.layout);
            if (layout.byteSize > this.byteLength) {
                throw new Error(`set structure type failed: new structure type is too large: ${layout.byteSize}`);
            }
            this._data = new StructuredBufferData(layout, this);
            this._structure = st;
        }
    }
    getUniformData() {
        return this._data;
    }
    static isValidArrayElementType(type) {
        if (type.isPrimitiveType()) {
            return type.scalarType !== PBPrimitiveType.BOOL && !type.isMatrixType();
        } else if (type.isStructType()) {
            for (const member of type.structMembers){
                if (!member.type.isPrimitiveType() || member.type.scalarType === PBPrimitiveType.BOOL || member.type.isMatrixType()) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }
}

export { WebGLStructuredBuffer };
//# sourceMappingURL=structuredbuffer_webgl.js.map
